import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TablePagination from '@material-ui/core/TablePagination';
import withWidth from '@material-ui/core/withWidth';

import StockDetail from '../mobile/StockDetail'
import BColor from '../BColor'
import PERSetting from './PERSetting';
import Typography from '@material-ui/core/Typography';
import PBRSetting from './PBRSetting';
import MyLoveList from '../mylove/MyLoveList';
import FavoriteBorder from '@material-ui/icons/Build'
import { exportExcel } from '../util/ExportCSV'
import Divider from '@material-ui/core/Divider'


function desc(a, b, orderBy) {
    if (b.happy[orderBy] < a.happy[orderBy]) {
        return -1;
    }
    if (b.happy[orderBy] > a.happy[orderBy]) {
        return 1;
    }

    return 0;
}


function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) =>
        [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: '股票代號', sid: 'name' },

    { id: 'p', numeric: false, disablePadding: false, label: '股價', sid: 'p' },
    { id: 'tp', numeric: false, disablePadding: false, label: '現行位階', sid: 'tp' },
    { id: 'dir', numeric: false, disablePadding: false, label: '趨勢方向', sid: 'dir' },
    { id: 'd1', numeric: false, disablePadding: false, label: '極度悲觀價', sid: 'd1' },
    { id: 'd2', numeric: false, disablePadding: false, label: '過度悲觀價', sid: 'd2' },
    { id: 'd3', numeric: false, disablePadding: false, label: '合理價', sid: 'd3' },
    { id: 'd4', numeric: false, disablePadding: false, label: '過度樂觀價', sid: 'd4' },
    { id: 'd5', numeric: false, disablePadding: false, label: '極度樂觀價', sid: 'd5' },

    { id: 'tp1', numeric: false, disablePadding: false, label: '現行位階', sid: 'tp1' },
    { id: 'u', numeric: false, disablePadding: false, label: '上通道', sid: 'u' },
    { id: 'avg', numeric: false, disablePadding: false, label: '20周均線', sid: 'avg' },
    { id: 'd', numeric: false, disablePadding: false, label: '下通道', sid: 'd' },

    { id: 'peg3', numeric: false, disablePadding: false, label: '稅後淨利成長', sid: 'peg3' },
    { id: 'peg1', numeric: false, disablePadding: false, label: 'EPS成長', sid: 'peg1' },
    { id: 'peg2', numeric: false, disablePadding: false, label: '預估EPS成長', sid: 'peg2' },

    { id: 'love', numeric: false, disablePadding: false, label: '自選清單' },
];

const color1 = BColor.blue1color// "#e0757e"
const color2 = BColor.column
const color3 = BColor.blackcolor


function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const handleOk = () => {
        setOpen(false);
        setOpen1(false);
        props.freecashupdate()
    };

    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead style={{ background: color1 }}>
            <PERSetting open={open} handleClose={handleClose} handleOk={handleOk}></PERSetting>
            <PBRSetting open={open1} handleClose={handleClose1} handleOk={handleOk}></PBRSetting>


            <TableRow style={{}}>
                <TableCell className={classes.stickya1} colSpan={1} style={{ color: "#FFFFFF", borderRight: '1px solid #dbdbdb' }}>股票名稱</TableCell>
                <TableCell className={classes.stickya} colSpan={8} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">樂活五線譜
                </TableCell>
                <TableCell className={classes.stickya} colSpan={4} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">樂活通道
                </TableCell>
                <TableCell className={classes.stickya} colSpan={3} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">本益成長比
                </TableCell>
                <TableCell className={classes.stickya} colSpan={1} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center"></TableCell>
            </TableRow>
            <TableRow style={{}}>
                {headCells.map(headCell => (
                    <TableCell
                        // style={{ margin: 0, paddingTop: 5, paddingBottom: 5, paddingLeft: headCell.paddingLeft, paddingRight: headCell.paddingRight }}
                        key={headCell.id}
                        className={(headCell.id === 'name' ? classes.stickyhh : classes.stickyh)}
                        style={{ ...((headCell.id === 'love' || headCell.id === 'tp1' || headCell.id === 'peg3') ? { borderLeft: '1px solid #dbdbdb' } : {}) }}
                        size="small"
                        align={headCell.id === 'name' ? 'left' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >{headCell.id === 'love' || headCell.id === 'tp1' || headCell.id === 'peg3' ? <div style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }}>{headCell.label}</div> :
                        <TableSortLabel
                            style={{ whiteSpace: 'nowrap', ...(headCell.id === 'name' ? { width: 10 } : {}), }}
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.sid)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        padding: 0,
        margin: 0,
        // marginTop: theme.spacing(1),
    },
  paper: {
    width: '100%',
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        // maxHeight: 550,
        overflowX: 'auto'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    vvvv: {
        fontSize: 10,
        padding: 5,
        color: BColor.faircolor,
        overflow: 'visible'
    },
    button1: {
        minWidth: 110,
    },
    button2: {
        minWidth: 90,
    },
    button3: {
        minWidth: 181,
    },
    stickyc: {
    paddingLeft: 10,
    paddingRight: 5,
    width: 10,
    whiteSpace: 'nowrap',
    position: '-webkit-sticky',
    position: 'sticky',
    zIndex: 1,
    left: 0,
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    stickya: {
        background: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 10,
        top: 0,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0,
        borderBottom: '1px solid #dbdbdb'
    },
stickyh: {
    backgroundColor: theme.palette.type === "light" ? color2 : "#000000",
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: 10,
        top: 37,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0
    }, //This is header
    stickya1: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 20,
        top: 0,
        left: 0,
        paddingTop: 7,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderBottom: '0px solid #dbdbdb'
    },
    stickyhh: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        top: 37,
        left: 0,
        zIndex: 20,
        paddingTop: 0,
        paddingBottom: 7,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderTop: '0px',
        borderRight: '1px solid #dbdbdb',
        borderBottom: '1px solid #dbdbdb'
    }
}));



function InPrice3Table(props) {
    const classes = useStyles();
    const loveItems = localStorage.getItem('love_stock') != null ? JSON.parse(localStorage.getItem('love_stock')) : []

    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('');
    const [selected, setSelected] = React.useState(loveItems);
    const [page, setPage] = React.useState(props.currentpage);
    const [dense, setDense] = React.useState(props.dense);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.currentcount);

    const [getStock, setSavestock] = React.useState(null);

    const [opendetail, setOpendetail] = React.useState(false)
    const [stockno, setStockNo] = React.useState(null);
    const [openstock, setOpenstock] = React.useState(null);
    const [lovemenu, setLovemenu] = React.useState(false)
    const myContainer = React.useRef(null);


    const handleLoveClick = stockNo => event => {
        setSavestock(stockNo);
        setLovemenu(true);
    };

    const handleLoveClose = () => {
        setLovemenu(false);
    };


    function getRowPageData(screen) {
        if (screen === 'xs')
            return [20]
        else return [10, 20, 40, 80, 150];
    }

    const rows = props.data

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.stock_no);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        props.pageupdate(newPage, props.currentcount)
    };

    const handleChangeRowsPerPage = event => {
        setPage(0)
        setRowsPerPage(parseInt(event.target.value, 10));
        props.pageupdate(0, parseInt(event.target.value, 10))

        // setPage(0);
    };


    function renderprice(status) {
        let k

        if (status === 0) {
            k = <Button size="small" style={{ minWidth: 180, background: BColor.downcolorbox, color: '#FFFFFF' }} className={classes.button1}>低於極度悲觀價</Button>
        } else if (status === 1) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.downcolorbox }} className={classes.button1}>極度悲觀價 ~ 過度悲傷價</Button>
        } else if (status === 2) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.faircolor }} className={classes.button1} >過度悲傷價 ~ 合理價</Button>
        } else if (status === 3) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.faircolor }} className={classes.button1} >合理價 ~ 過度樂觀價</Button>
        } else if (status === 4) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.upcolorbox }} className={classes.button1} >過度樂觀價 ~ 極度樂觀價</Button>
        } else if (status === 5) {
            k = <Button size="small" style={{ minWidth: 180, background: BColor.upcolorbox, color: '#FFFFFF' }} className={classes.button1} >大於極度樂觀價</Button>
        } else {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.nodatacolor }} className={classes.button1} >-</Button>
        }

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0 }} size="small" align="left">
            {k}
        </TableCell>
    }

    function renderprice1(status) {
        let k

        if (status === 0) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.downcolorbox }} className={classes.button1}>空方向下</Button>
        } else if (status === 1) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.upcolorbox }} className={classes.button1} >多方向上</Button>
        } else if (status === 2) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.faircolor }} className={classes.button1} >盤整型態</Button>
        } else {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.nodatacolor }} className={classes.button1} >-</Button>
        }

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0 }} size="small" align="left">
            {k}
        </TableCell>
    }

    // function render1(value) {
    //     let color = BColor.faircolor

    //     let k = value + '元'
    //     if (value < 0) k = '-'

    //     return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0 }} size="small" align="left">
    //         <Button size="small" variant="outlined" style={{ minWidth: 110, color: color, marginRight: 1 }} className={classes.button2} >
    //             {k}
    //         </Button>
    //     </TableCell>
    // }

    function render1(value, unit) {
        let color = BColor.faircolor

        let k = value + unit
        if (value < 0) k = '-'

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0 }} size="small" align="left">
            <Button size="small" variant="outlined" style={{ minWidth: 110, color: color, marginRight: 1 }} className={classes.button2} >
                {k}
            </Button>
        </TableCell>
    }

    function render3(value) {
        let color = BColor.faircolor

        let k = value
        if (value < 0) k = '-'

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 1, paddingRight: 0, borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
            <Button size="small" variant="outlined" style={{ minWidth: 110, color: color, marginRight: 1 }} className={classes.button2} >
                {k}
            </Button>
        </TableCell>
    }

    function renderTp1(happy) {
        let k

        if (happy.d != -1 && happy.p <= happy.d) {
            k = <Button size="small" style={{ minWidth: 180, background: BColor.downcolorbox, color: '#FFFFFF' }} className={classes.button1}>低於下通道</Button>
        } else if (happy.d != -1 && happy.avg != -1 && happy.p < happy.avg && happy.p > happy.d) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.downcolorbox }} className={classes.button1}>20周均線 ~ 下通道</Button>
        } else if (happy.avg != -1 && happy.p === happy.avg) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.faircolor }} className={classes.button1} >20周均線附近</Button>
        } else if (happy.u != -1 && happy.avg != -1 && happy.p > happy.avg && happy.p < happy.u) {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.faircolor }} className={classes.button1} >上通道 ~ 20周均線</Button>
        } else if (happy.u != -1 && happy.p >= happy.u) {
            k = <Button size="small" style={{ minWidth: 180, background: BColor.upcolorbox, color: '#FFFFFF' }} className={classes.button1} >高於上通道</Button>
        } else {
            k = <Button size="small" variant="outlined" style={{ minWidth: 180, color: BColor.nodatacolor }} className={classes.button1} >-</Button>
        }

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0 }} size="small" align="left">
            {k}
        </TableCell>
    }


    const openDetail = (stockno) => {
        if (props.detailUpdate != undefined) props.detailUpdate(true)
        setStockNo(stockno)
        setOpendetail(true)
    }

    const closeDetail = () => {
        if (props.closeupdate != undefined) props.closeupdate()
        if (props.detailUpdate != undefined) props.detailUpdate(false)
        setOpendetail(false)
    }

    const getAllIds = () => {
        return props.data.map(row => {
            return row.market_company.stock_no
        })
    }

    return (
        <div className={classes.root}>
            <StockDetail open={opendetail} allIds={getAllIds()} handleClose={closeDetail} stockno={stockno} ismobile={props.ismobile} />
            <MyLoveList open={lovemenu} handleClose={handleLoveClose} stockno={getStock} myloveupdate={props.myloveupdate} />

            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}
                    style={{ ...((localStorage.getItem('hfix') == null || localStorage.getItem('hfix') === "y") ? { maxHeight: '70vh' } : {}) }}
                >
                    <Table
                        ref={myContainer}
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >

                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            freecashupdate={props.freecashupdate}
                        />
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .map((row, index) => {
                                    //   const isItemSelected = isSelected(row.stock_no);

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.market_company.stock_no}
                                        >
                                            <TableCell className={classes.stickyc} style={{ borderRight: '1px solid #dbdbdb', borderBottom: '1px solid #d9d9d9' }} padding="none" size="small" align="left">
                                                <Link
    component="button"
    variant="body2"
    onClick={() => {
        openDetail(row.market_company.stock_no)
    }}
    color="inherit"
>{row.market_company.short_name}
</Link>
                                                <br />
                                                <Link
                                                    style={{ color: BColor.upcolor }}
                                                    component="button"
                                                    variant="caption"
                                                    onClick={() => openDetail(row.market_company.stock_no)}
                                                >
                                                    {row.market_company.stock_no}
                                                </Link>
                                            </TableCell>

                                            {row.happy != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="center" size="small"　>
                                                {row.happy.p}元
                                            </TableCell> : null}

                                            {row.happy != undefined ? renderprice(row.happy.tp) : null}
                                            {row.happy != undefined ? renderprice1(row.happy.dir) : null}
                                            {row.happy != undefined ? render1(row.happy.d1, '元') : null}
                                            {row.happy != undefined ? render1(row.happy.d2, '元') : null}
                                            {row.happy != undefined ? render1(row.happy.d3, '元') : null}
                                            {row.happy != undefined ? render1(row.happy.d4, '元') : null}
                                            {row.happy != undefined ? render1(row.happy.d5, '元') : null}

                                            {row.happy != undefined ? renderTp1(row.happy) : null}
                                            {row.happy != undefined ? render1(row.happy.u, '元') : null}
                                            {row.happy != undefined ? render1(row.happy.avg, '元') : null}
                                            {row.happy != undefined ? render1(row.happy.d, '元') : null}

                                            {row.happy != undefined ? render3(row.happy.peg3) : null}
                                            {row.happy != undefined ? render1(row.happy.peg1, '') : null}
                                            {row.happy != undefined ? render1(row.happy.peg2, '') : null}


                                            {row.happy == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} colSpan="7" size="small"　>
                                                <Button size="small" variant="outlined" style={{ width: '100%', color: BColor.nodatacolor }} className={classes.button2} >
                                                    無法評價
                                                </Button>
                                            </TableCell> : null}


                                            <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 5, paddingRight: 5 }} align="center">
                                                <Button
                                                    size="small"
                                                    onClick={handleLoveClick(row.market_company.stock_no)}
                                                    variant="outlined"
                                                    style={{ width: '100%', color: BColor.faircolor }}
                                                    className={classes.button}
                                                    startIcon={<FavoriteBorder />}
                                                >
                                                    管理
                                                </Button>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                {props.disablepage ?
                    <div><Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                    匯出
                </Button></div>
                    : <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                        <Divider orientation="vertical" flexItem />
                        <Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                            匯出
                        </Button>
                        <Divider orientation="vertical" flexItem />
                        <TablePagination
                            rowsPerPageOptions={getRowPageData(props.width)}
                            component="div"
                            count={props.total}
                            rowsPerPage={props.currentcount}
                            page={props.currentpage}
                            labelRowsPerPage={'每頁'}
                            labelDisplayedRows={({ from, to, count }) => `第${from}筆，共 ${count}筆`}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        /></div>
                }
            </Paper>
        </div>
    );
}

export default withWidth()(InPrice3Table);
